import MintOauthRedirectPage from "@/features/mint-oauth-redirect/pages/MintOauthRedirect";
import { withAuth } from "@/hoc/withAuth";

const MintOauthRedirect = () => {
  return <MintOauthRedirectPage />;
};

export default withAuth(MintOauthRedirect);
